import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import PageTitle from "../Misc/PageTitle";
import GenerateDigitalBillReceipt from "./GenerateDigitalBillReceipt";

function SingleTransaction({ baseURL, clientID, AppDisplayName, ClientName, currency, appSettings }) {
    const location = useLocation();
    console.log(location, 'loc state')

    const navigate = useNavigate();

    const transactionHistory = location.state;

    const [showModal, setShowModal] = useState(false);

    const handleShow = () => setShowModal(!showModal);

    const [voucherIssued, setVoucherIssued] = useState("No");

    const [voucherRedeemed, setVoucherRedeemed] = useState({});

    useEffect(() => {
        console.log(transactionHistory, "transaction history");
        if (!transactionHistory) {
            navigate("/history");
        } else {
            if (transactionHistory?.VOUCHER_ISSUED?.length > 0) {
                setVoucherIssued("Yes");
            }

            if (transactionHistory?.VOUCHER_REDEEMED?.length > 0) {
                setVoucherRedeemed(transactionHistory?.VOUCHER_REDEEMED[0]);
            }
        }
    }, []);

    return (
        <AnimatedPage>
            <div className="position-sticky z-2 bg-wafaa-white-3 mh-100dvh">
                <PageTitle name="TRANSACTION DETAILS" />

                <div className="w-100 pb-5 bg-wafaa-white-3">
                    
                    <div className=" font-size-13 w-90 mx-auto  shadow p-3 rounded-3 px-3 pb-1 pt-3 mt-3 bg-wafaa-white-2 border border-1 border-wafaa-grey-2">
                        <div className="d-flex justify-content-between ">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-grey fw-semibold">{AppDisplayName ? AppDisplayName : "True Value"} ID Scan</p>
                            </div>

                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold">
                                    {transactionHistory && transactionHistory?.ITEM_DETAILS ? moment(transactionHistory?.ITEM_DETAILS[0].TRAN_DATE).format("DD MM YYYY, hh:mm:ss a") : ""}
                                </p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-grey fw-semibold"> {AppDisplayName ? AppDisplayName : "TRUE VALUE"} ID</p>
                            </div>
                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold">{transactionHistory && transactionHistory?.POINTS_EARNED ? transactionHistory?.POINTS_EARNED[0].CUSTOMER_CODE : ""}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-grey fw-semibold">Used Coupon</p>
                            </div>
                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold">{transactionHistory?.VOUCHER_REDEEMED.length ? "Yes" : "No"}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-grey fw-semibold">Issued Coupon</p>
                            </div>
                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold">{voucherIssued}</p>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between  border border-1 border-top-0 border-start-0 border-end-0 border-wafaa-grey-2">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "900",
                                    }}
                                    className="text-wafaa-dark-blue-2"
                                >
                                    Total Paid
                                </p>
                            </div>
                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "900",
                                    }}
                                    className="text-wafaa-dark-blue-2 fw-semibold"
                                >
                                    {transactionHistory?.BILL_AMOUNT} {currency}
                                </p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between  my-3">
                            <div
                                style={{
                                    width: "50%",
                                    fontSize: "15px",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold m-0">{transactionHistory && transactionHistory?.POINTS_EARNED[0]?.POINTS_EARNED > 1 ? "Points Earned" : "Point Earned"}</p>
                            </div>
                            <div
                                className="d-flex justify-content-end align-items-center"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-bright-green text-end m-0  fw-semibold">
                                    +{transactionHistory && transactionHistory?.POINTS_EARNED ? transactionHistory?.POINTS_EARNED[0]?.POINTS_EARNED : "0"} pts
                                </p>
                            </div>
                        </div>
                    </div>

                    {
                        <GenerateDigitalBillReceipt
                            cardNo={transactionHistory?.CARD_NO}
                            billDate={transactionHistory?.ITEM_DETAILS[0].TRAN_DATE}
                            clientName={ClientName}
                            currency={currency}
                            appSettings={appSettings}
                            billRef={transactionHistory?.BILLREF}
                            items={transactionHistory?.ITEM_DETAILS}
                            pointsEarned={transactionHistory?.POINTS_EARNED[0]?.POINTS_EARNED || 0}
                            handleShow={handleShow}
                            showModal={showModal}
                        />
                    }

                    <div className="max-width-700" style={{ position: "fixed", bottom: "0%", left: "50%", transform: "translateX(-50%)", width: "90%" }}>
                        <button
                            onClick={handleShow}
                            className="btn btn-primary bg-wafaa-purple font-size-14"
                            style={{
                                width: "100%",
                                height: "45px",
                                color: "white",
                                textTransform: "capitalize",
                                marginBlock: "1rem",
                                border: "none",
                                cursor: "pointer",
                                borderRadius: "4px",
                                webkittapHighlightColor: "none",
                            }}
                        >
                            Generate Digital Receipt
                        </button>
                    </div>
                </div>
            </div>
        </AnimatedPage>
    );
}
export default SingleTransaction;
